import React from "react";
import { Activity, BarChart3, Bell, BriefcaseBusiness, KeyRound, Settings } from "lucide-react";

export interface MenuItem {
  key: string;
  label: string;
  icon: React.ComponentType<{ className?: string }>;
}

export const appConfig = {
  name: "Harness Station",
  description: "智能体工作台",
  icon: {
    gradient: "from-brand-500 to-brand-600",
    component: BriefcaseBusiness as React.ComponentType<{ className?: string }>,
  },
};

export function getMenuItems(t: (key: string) => string): MenuItem[] {
  return [
    {
      key: "dashboard",
      icon: BarChart3,
      label: t("nav:dashboard"),
    },
    {
      key: "notifications",
      icon: Bell,
      label: t("nav:notifications"),
    },
    {
      key: "recent",
      icon: Activity,
      label: t("nav:recent"),
    },
    {
      key: "permissions",
      icon: KeyRound,
      label: t("nav:permissions"),
    },
    {
      key: "profile",
      icon: Settings,
      label: t("nav:settings"),
    },
  ];
}
